import axios from "axios";

const HOME_URL = "/";

export function useApiService() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
  });

  const collectionResponseHandler = async response =>
    Promise.resolve({
      data: response.data,
      raw: response
    });

  const singularResponseHandler = async response =>
    Promise.resolve({
      data: response.data,
      raw: response
    });

  const generalErrorHandler = error => {
    if (error.response.status === 401) {
      window.location.href = HOME_URL;
    }

    console.error(`ApiService ${error}`);

    return Promise.reject(error);
  };

  // Out of use
  const request = (method, resource, params, config) => {
    return api
      .request({
        method,
        url: `${resource}`,
        params,
        ...config
      })
      .catch(generalErrorHandler);
  };

  const get = (apiUrl, params) => {
    return api
      .request({
        method: "get",
        url: `${apiUrl}`,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  // Out of use
  const query = (resource, params) => {
    return api
      .request({
        method: "get",
        url: `${resource}`,
        params
      })
      .then(collectionResponseHandler)
      .catch(generalErrorHandler);
  };

  const save = (apiUrl, data, params) => {
    return api
      .request({
        method: "post",
        url: `${apiUrl}`,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  // Out of use
  const update = (resource, slug = "", data, params) => {
    return api
      .request({
        method: "put",
        url: `${resource}/${slug}`,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  // Out of use
  const patch = (resource, slug = "", data, params) => {
    return api
      .request({
        method: "patch",
        url: slug ? `${resource}/${slug}` : resource,
        data,
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  // Out of use
  const remove = (resource, slug = "") => {
    return api
      .request({
        method: "delete",
        url: `${resource}/${slug}`
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  // Out of use
  const upload = (resource, file, type, params) => {
    return api
      .request({
        method: "post",
        url: resource,
        data: file,
        headers: {
          "Content-Type": type
        },
        params
      })
      .then(singularResponseHandler)
      .catch(generalErrorHandler);
  };

  return {
    request,
    get,
    query,
    save,
    update,
    patch,
    remove,
    upload
  };
}
